import { Ref, useRef } from 'react';
import useSize from '../useSize';
import { SpringValue, useSpring } from 'react-spring';

type ReturnType = {
  innerRef: Ref<HTMLDivElement>;
  outer: {
    opacity: SpringValue<number>;
    height: SpringValue<number>;
  };
  inner: { y: SpringValue<number> };
};

/**
 *
 * @param isOpen is the collapsible children shown
 * @returns animation styles to make a block open & close smoothly
 */
const useCollapseAnimation = ({ isOpen }: { isOpen: boolean }): ReturnType => {
  const contentRef = useRef<HTMLDivElement | null>(null);

  const [{ height: contentHeight }] = useSize(contentRef);

  const { opacity } = useSpring({
    from: { opacity: 0 },
    to: { opacity: isOpen ? 1 : 0 },
    config: {
      tension: 2000,
      clamp: true,
    },
  });

  const { height, y } = useSpring({
    from: { height: 0, y: 0 },
    to: {
      height: isOpen ? contentHeight + 5 : 0,
      y: isOpen ? 0 : 20,
    },
  });

  return {
    innerRef: contentRef,
    outer: {
      opacity,
      height,
    },
    inner: { y },
  };
};

export default useCollapseAnimation;
